<template>
  <div class="sakura-portrait">
    <!-- 活动标题 -->
    <div v-wechat-title="'《魔卡少女樱：回忆钥匙》制作头像活动'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" name="fade">
      <div @touchmove.prevent class="preloading preloading-sakura" v-show="preloadingShow"></div>
    </transition>

    <Header v-if="true" :config="headerConfig" :isOnline="is_reward" @reInit="reInit" :isShowInfo="true" />

    <!-- <Header v-if="true" :config="headerConfig" :isShowInfo="true" @changeLoginPopup="changeLogin" />
    <Login
      ref="login-wrapper"
      gameName="snail"
    />-->

    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" @channelCallback="selectCallback" :gameName="gameName" :downloadUrl="downloadUrl"
      :loginTypes="loginTypes" :autoOpenOS="autoOpenOS" :freeLogin="true" @selectCallback="selectCallback" game_id="74"
      :isOnline="is_reward"></Login>
    <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>

    <div class="sakura-box">
      <div class="home-page">
        <div class="logo"></div>
        <div class="make-btn" @click="gotoMake"></div>
        <div class="title">
          <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
            <img src="https://download4.qcplay.com/h5-images/active/sakura/portrait/main_title.png" />
          </transition>
        </div>
        <div class="tips"></div>
      </div>
      <!-- 活动页 -->
      <div class="act-page" ref="makeDom">
        <div class="portrait-show-box">
          <div class="frame"></div>
          <div class="por-back"></div>
          <div class="por-box" ref="portraitDom">
            <div class="por-xiaoying">
              <img :src="`//download4.qcplay.com/cherry/pic/pic_xiaoying/${showSrc1}.png`
                " alt />
            </div>
            <div class="por-background">
              <img :src="`//download4.qcplay.com/cherry/pic/pic_back2/${showSrc2}.png`
                " alt />
            </div>
            <div class="por-decorate">
              <img :src="`//download4.qcplay.com/cherry/pic/pic_deco2/${showSrc3}.png`
                " alt />
            </div>
          </div>
        </div>
        <superslide :options="options" class="select-box">
          <div class="select-tit hd">
            <ul>
              <li class="li-01 on"></li>
              <li class="li-02"></li>
              <li class="li-03"></li>
            </ul>
          </div>
          <div class="select-card-box bd">
            <ul class="por-xy">
              <li>
                <span v-for="item in listData" :key="item.id" @click="itemClick(item, 1)">
                  <img :src="'//download4.qcplay.com/cherry/pic/xiaoying/' +
                    item.id +
                    '.png'
                    " alt />
                </span>
              </li>
              <li>
                <span v-for="item in backData" :key="item.id" @click="itemClick(item, 2)">
                  <img :src="'//download4.qcplay.com/cherry/pic/back/' +
                    item.id +
                    '.png'
                    " alt />
                </span>
              </li>
              <li>
                <span v-for="item in decoData" :key="item.id" @click="itemClick(item, 3)">
                  <img :src="'//download4.qcplay.com/cherry/pic/deco/' +
                    item.id +
                    '.png'
                    " alt />
                </span>
              </li>
            </ul>
          </div>
        </superslide>
        <div class="btn-box">
          <div v-if="is_reward == 0" class="save-btn-before" @click="saveImgBefore" data-event="保存头像(上线前)"></div>
          <div v-else class="save-btn-after" @click="saveImgAfter" data-event="保存头像(上线后)"></div>
          <div class="upload-btn">
            <!-- 上传按钮 -->
            <div v-if="!userInfo.account" class="login-prevent" @click="login" data-event="未登录"></div>
            <!-- 领取按钮 -->
            <div v-if="!is_reward && is_url == 1 && !reward_status" class="receive-prevent-before"
              @click="receivePreventBefore" data-event="上线前登录上传后没领奖"></div>
            <!-- 上传按钮 -->
            <div v-if="is_reward == 1 && userInfo.account && !userInfo.role_id" class="none-role-prevent"
              @click="rolePrevent" data-event="上线登录后上传无角色"></div>
            <!-- 领取按钮 -->
            <div v-if="is_reward == 1 && userInfo.account && is_url == 1 && !reward_status && userInfo.role_id"
              class="receive-prevent" @click="receivePrevent" data-event="上线登录上传后没领奖"></div>
            <!-- 领取按钮 -->
            <div v-if="userInfo.account && is_reward == 1 && is_url == 1 && reward_status" class="upload-prevent"
              @click="uploadPrevent" data-event="上线后登录并上传了"></div>
            <!-- 上传按钮 -->
            <div v-if="!is_reward && !is_url && userInfo.account" class="upload-file-before">
              <input type="file" @change="onChanged" ref="uploadInput" data-event="上传截图领好礼(上线前)" />
            </div>
            <!-- 上传按钮 -->
            <div v-if="is_reward && !is_url && userInfo.role_id" class="upload-file-after">
              <input type="file" @change="onChanged" ref="uploadInput" data-event="上传截图领好礼(上线后)" />
            </div>
          </div>
        </div>
        <!-- 保存头像相关DOM -->
        <div class="save-box" v-if="saveDom" ref="imageDom">
          <img src="https://download4.qcplay.com/h5-images/active/sakura/portrait/portrait_pop_bg.png" />
          <div class="save-img"></div>
        </div>

        <div class="act-detail"></div>
        <!-- <Footer :gameName="gameName" /> -->
      </div>
    </div>

    <!-- 弹窗 -->
    <!-- 保存头像弹窗(上线前) -->
    <div class="save-portrait-wrap popup_wrap" v-show="saveShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="save-portrait-box popup_wrap-box" v-show="saveShow">
          <div class="pic-frame"></div>
          <div class="pic-back"></div>
          <div class="pic-box">
            <img :src="portraitImg" alt="分享图片" />
          </div>
          <div class="close-bg" v-show="saveShow" @click="closeSave()"></div>
          <div class="close-btn" v-show="saveShow" @click="closeSave()"></div>
        </div>
      </transition>
    </div>

    <!-- 保存头像弹窗(上线后) -->
    <div class="save-portrait-wrap-2 popup_wrap" v-show="saveShow2">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="save-portrait-box popup_wrap-box" v-show="saveShow2">
          <div class="pic-frame"></div>
          <div class="pic-back"></div>
          <div class="pic-box">
            <img :src="portraitImg" alt="分享图片" />
          </div>
          <div class="close-bg" v-show="saveShow2" @click="closeSave2()"></div>
          <div class="close-btn" v-show="saveShow2" @click="closeSave2()"></div>
        </div>
      </transition>
    </div>

    <!--  领取过奖励弹窗 -->
    <div class="award-got-wrap popup_wrap" v-show="awardGot">
      <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="award-got-box popup_wrap-box" v-show="awardGot">
          <div class="close-bg" v-show="awardGot" @click="closeAwardGot()"></div>
          <div class="close-btn" v-show="awardGot" @click="closeAwardGot()"></div>
        </div>
      </transition>
    </div>

    <!--  已上传截图弹窗(上线前)-->
    <div class="upload-got-wrap popup_wrap" v-show="hasUpload">
      <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="upload-got-box popup_wrap-box" v-show="hasUpload">
          <div class="close-bg" v-show="hasUpload" @click="closeHadUpload()"></div>
          <div class="close-btn" v-show="hasUpload" @click="closeHadUpload()"></div>
          <div class="confirm-btn" v-show="hasUpload" @click="closeHadUpload()"></div>
        </div>
      </transition>
    </div>

    <!--  已上传截图弹窗(上线后)-->
    <div class="upload-got-wrap-2 popup_wrap" v-show="hasUpload2">
      <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="upload-got-box popup_wrap-box" v-show="hasUpload2">
          <div class="close-bg" v-show="hasUpload2" @click="closeHadUpload2()"></div>
          <div class="close-btn" v-show="hasUpload2" @click="closeHadUpload2()"></div>
        </div>
      </transition>
    </div>

    <!--  领取奖励确认弹窗(上线后)-->
    <div class="receive-award-wrap popup_wrap" v-show="receiveAward">
      <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="receive-award-box popup_wrap-box" v-show="receiveAward">
          <p class="user-info">{{ userInfo["role_name"] + "[" + userInfo["server_name"] + "]" }}</p>
          <div class="close-bg" v-show="receiveAward" @click="closeReceiveAward()"></div>
          <div class="close-btn" v-show="receiveAward" @click="closeReceiveAward()"></div>
          <div class="confirm-btn" v-show="receiveAward" @click="closeReceiveAward()"></div>
        </div>
      </transition>
    </div>

    <!-- PC端遮层 -->
    <div class="pc-popup" v-show="pcShow">

    </div>
  </div>
</template>
<script>
// import Login from 'qc-login'
import { Toast, Indicator } from 'mint-ui'
import Clipboard from 'clipboard'
import { mapState, mapMutations, mapActions } from 'vuex'
import Os from '@/components/os'
import Login from '@/components/login'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import MySwiper from '@/components/MySwiper'
import { headerConfig } from '../../headerConfig'
import { onGetInitDataAPI, uploadPicAPI } from '../api'
import { getTimeStamp, buriedLogger, monitoringOs } from '@/utils/utils'
import { generateQRCode, generateCanvasImage } from '@/utils/share'
import axios from 'axios'

export default {
  name: 'sakura-portrait',
  components: {
    Header,
    Footer,
    Login,
    Os,
    MySwiper,
  },

  data() {
    return {
      headerConfig,
      gameName: 'sakura',
      logger: null,
      downloadUrl: 'https://sakura.qingcijoy.com/official/index.html',
      preloadingShow: true,
      titleShow: true,
      noSwiperClass: '', // swiper-no-swiping
      shareLink: '',
      saveDom: true,
      portraitImg: null,
      activity: {}, // 初始化   -> 活动数据
      saveShow: false, //保存头像（上线前）
      saveShow2: false, //保存头像（上线后）
      awardGot: false, //是否领取过奖励
      hasUpload: false, //是否已上传截图（上线前）
      hasUpload2: false, //是否已上传截图（上线后）
      receiveAward: false, //确认领奖弹窗
      is_reward: 0, //是否上线
      is_url: null, //是否上传
      reward_status: false, //是否领奖
      autoOpenOS: false, //是否需要区组选角
      // 其他数据
      loginTypes: ['sms'],
      aa: '',
      options: {
        mainCell: '.bd ul',
        // vis: 4,
        effect: 'leftLoop',
        trigger: 'click',
        easing: 'swing',
      },
      showSrc1: '1',
      showSrc2: '0',
      showSrc3: '0',
      listData: [
        { id: 1, data: 11 },
        { id: 2, data: 12 },
        { id: 3, data: 13 },
        { id: 4, data: 14 },
        { id: 5, data: 15 },
        { id: 6, data: 16 },
        { id: 7, data: 17 },
        { id: 8, data: 18 },
      ],
      backData: [
        { id: 1, data: 11 },
        { id: 2, data: 12 },
        { id: 3, data: 13 },
        { id: 4, data: 14 },
        { id: 5, data: 15 },
        { id: 6, data: 16 },
        { id: 7, data: 17 },
        { id: 8, data: 18 },
      ],
      decoData: [
        { id: 1, data: 11 },
        { id: 2, data: 12 },
        { id: 3, data: 13 },
        { id: 4, data: 14 },
        { id: 5, data: 15 },
        { id: 6, data: 16 },
        { id: 7, data: 17 },
        { id: 8, data: 18 },
      ],
      pcShow: false
    }
  },
  created() {
    console.log(monitoringOs());
    if (monitoringOs() === 'pc') return this.pcShow = true
    // 清空store上的用户数据
    this.setInitActiveInfo()
    this.setInitUserInfo()

    // 初始化
    onGetInitDataAPI().then((response) => {
      // console.log(3434343433);
      this.onInitDataCallback({
        ...response,
        data: {
          user_info: response.data.userinfo,
          activity: response.data.activity,
        },
      })
      if (response.code == 200) {
        this.afterInitLogin(response)
      }
      this.preloadingShow = false
    })

    // 埋点
    const bl = buriedLogger('sakura', '小樱_头像H5活动')
    this.logger = bl
  },
  updated() {
    // console.log("userInfohhhhhhhhhhhhhhhh:",this.userInfo);
    // console.log("is_url:",this.is_url);
  },
  mounted() {
    // 获取uuid-api
    this.$nextTick(() => {
      this.isSetShare()
    })
  },
  computed: {
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        // console.log("newValue", newValue);
        // console.log("oldValue", oldValue);
        if (!newValue.user_id) {
          // TAG: 注销的时候
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          const { protocol, host } = window.location
        }
      },
    },
  },
  methods: {
    // changeLogin () {
    //   console.log(222222 ,this);
    //   this.$refs['login-wrapper'].isShowLogin = true
    // },

    // 获取用户数据之后
    afterInitLogin(response) {
      const { code } = response || {}
      if (Number(code) === 200) {
        this.setActivity(response.data.activity)
      }
      // console.log(response.data);
    },

    // 【活动数据】设置游戏信息
    setActivity(activity) {
      this.is_reward = activity.is_reward || 0
      this.autoOpenOS = !this.is_reward ? false : true
      this.is_url = activity.is_url || 0
      this.reward_status = activity.reward_status || false
    },

    reInit() {
      onGetInitDataAPI().then((response) => {
        this.onInitDataCallback({
          ...response,
          data: {
            user_info: response.data.userinfo,
            activity: response.data.activity,
          },
        })
        this.afterInitLogin(response)
      })
    },

    // 保存头像（上线前）
    saveImgBefore() {
      // if (this.userInfo.rid === undefined) {
      //   this.changeLoginPopup(true);
      //   return false;
      // }
      this.closeSave()
      this.initShareData()
      this.logger.sum('save-btn-before')
    },
    // 保存头像（上线后）
    saveImgAfter() {
      this.closeSave2()
      this.initShareData()
      this.logger.sum('save-btn-after')
    },
    // 预约按钮
    gotoMake() {
      this.logger.sum('make-btn')
      // console.log(this.$refs.makeDom);
      // const scrollToTop = this.$refs.makeDom.getBoundingClientRect().top;   //滚动条距离顶部的距离
      // console.log("scrollToTop", scrollToTop);
      // $("html,body").animate({
      //   scrollTop: scrollToTop
      // }, 500);
      this.$refs.makeDom.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    },
    // 保存头像弹窗（上线前）
    closeSave() {
      this.saveShow = !this.saveShow
    },
    // 保存头像弹窗（上线后）
    closeSave2() {
      this.saveShow2 = !this.saveShow2
    },
    // 领取过奖励弹窗
    closeAwardGot() {
      this.awardGot = !this.awardGot
    },
    // 已经上传过截图弹窗（上线前）
    closeHadUpload() {
      this.hasUpload = !this.hasUpload
    },
    // 已经上传过截图弹窗（上线后）
    closeHadUpload2() {
      this.hasUpload2 = !this.hasUpload2
    },
    // 确认领奖弹窗（上线后）
    closeReceiveAward() {
      this.receiveAward = !this.receiveAward
    },
    itemClick(item, type) {
      var lastSelect = this[`showSrc${type}`]
      if (lastSelect == item.id) {
        if (type !== 1) {
          this[`showSrc${type}`] = 0
        }
      } else {
        this[`showSrc${type}`] = item.id
      }
    },
    login() {
      // 防止未登录按钮
      this.logger.sum('login-prevent-btn')
      return this.changeLoginPopup(true)
    },
    uploadPrevent() {
      // 上线后防止重复上传按钮
      this.logger.sum('upload-prevent-btn')
      if (this.is_reward == 1 && this.reward_status == true)
        return this.closeAwardGot()

      if (this.is_reward == 0 && this.is_url == 1) return this.closeHadUpload()

      //上线状态 上传后
      if (this.is_reward == 1 && this.is_url == 1) return this.closeHadUpload2()
    },
    rolePrevent() {
      // 上线后没有角色按钮
      this.logger.sum('none-role-prevent-btn')
      // // 获取角色信息
      // GetRoleList({
      //   account: this.userInfo.account,
      //   page_id: 11,
      //   app_id: 74
      // }).then((response) => {
      //   if (response.data.code == 200) {
      //     // this.onToast('很抱歉，您还暂未绑定角色，请先完成角色绑定后再领奖~');
      //     this.changeOsPopup(true)
      //   }
      //   if (response.data.code == 401) {
      //     // this.onToast('很抱歉，您还暂未创建角色，请先完成角色创建后再领奖~')
      //     this.changeLoginPopup(true)
      //   }
      // })
      this.changeLoginPopup(true)
    },
    receivePrevent() {
      // 上线前防止领取按钮
      this.logger.sum('receive-prevent-btn')
      uploadPicAPI().then((response) => {
        if (response.code == 200) {
          // console.log("成功");
          onGetInitDataAPI().then((response) => {
            this.onInitDataCallback({
              ...response,
              data: {
                user_info: response.data.userinfo,
                activity: response.data.activity,
              },
            })
            this.afterInitLogin(response)

            return this.is_reward == 1
              ? this.closeHadUpload2()
              : this.closeHadUpload()
          })
        }
        if (response.code == 404) {
          this.closeHadUpload()
        }
        else {
          // console.log(response.message);
          this.onToast(response.message);
        }
      })
    },
    receivePreventBefore() {
      this.hasUpload = !this.hasUpload
    },
    onChanged(e) {
      this.logger.sum('upload-btn')
      // 上线状态 领取过奖励
      if (this.is_reward == 1 && this.reward_status == true)
        return this.closeAwardGot()

      //未上线状态 上传过
      if (this.is_reward == 0 && this.is_url == 1) return this.closeHadUpload()

      //上线状态 上传过
      if (this.is_reward == 1 && this.is_url == 1) return this.closeHadUpload2()

      // //上线状态 未上传过
      // if(this.is_reward == 1 && this.is_url == 0 ) return this.closeHadUpload2();

      var files = this.$refs.uploadInput.files[0]
      if (!files) {
        return this.onToast('请重新选择图片上传~')
      }

      // console.log(files.type);

      if (!['image/jpeg', 'image/jpg', 'image/png'].includes(files.type)) {
        return this.onToast('格式错误，请选择jpg、png或jpeg图片格式上传~')
      }

      var fileSize = files.size / (1024 * 1024)
      if (fileSize > 8) {
        this.$refs.uploadInput.value = null
        return this.onToast('图片大小不超过8M，请重新选择~')
      }

      var formData = new FormData()
      formData.append('file', e.target.files[0])

      Indicator.open({
        text: '上传中...',
        spinnerType: 'fading-circle',
      })
      axios
        .post('//api.qingcigame.com/snail/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((res) => {
          // console.log(res);
          // console.log(res.data.data.path);
          uploadPicAPI({ url: res.data.data.path }).then((response) => {
            if (response.code == 200) {
              // console.log("成功");
              onGetInitDataAPI().then((response) => {
                this.onInitDataCallback({
                  ...response,
                  data: {
                    user_info: response.data.userinfo,
                    activity: response.data.activity,
                  },
                })
                this.afterInitLogin(response)

                return this.is_reward == 1
                  ? this.closeHadUpload2()
                  : this.closeHadUpload()
                // return this.closeHadUpload();
              })
            } else {
              // console.log(response.message);
              this.onToast(response.message);
            }
          })
        })
        .catch((err) => {
          // this.onToast("图片大小不超过8M，请重新选择~");
        })
        .finally(() => Indicator.close())
    },
    initShareData(info) {
      try {
        // console.log(info);
        // this.setShare({ link: this.shareLink });
        // this.qrcode(`${this.helpUrl}?id=${info.user_id}`);
        this.$nextTick(() => {
          // console.log(8888888888);
          this.generateShareImage()
        })
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err)
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb',
      })
    },
    // 分享图片设置
    generateShareImage() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle',
      })
      generateCanvasImage(this.$refs.portraitDom)
        .then((canvas) => {
          // console.log(66666);
          this.portraitImg = canvas.toDataURL('image/png') // 可将 canvas 转为 base64 格式
          // console.log("success: 图片生成成功");
        })
        .catch((err) => {
          // console.log("err: 图片生成失败", err.message);
        })
        .finally(() => Indicator.close())
    },
    // 复制链接
    onCopy() {
      const clipboard = new Clipboard('#clipboard-btn')
      clipboard.on('success', (e) => {
        this.onToast('复制成功')
        e.clearSelection()
      })
      clipboard.on('error', (e) => {
        this.onToast('复制失败')
      })
      this.onCount('copy_link')
    },
    // swiper轮播
    mySwiper() {
      // this.$refs.mySwiper.init();
    },
    // swiper 翻下一页
    nextPage() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true)
      } else {
        this.$refs.mySwiper.nextSwiper(1)
      }
    },
    // 选择角色后
    selectCallback() {
      // console.log(111111);
      onGetInitDataAPI().then((response) => {
        this.onInitDataCallback({
          ...response,
          data: {
            user_info: response.data.userinfo,
            activity: response.data.activity,
          },
        })
        if (response.code == 200) {
          this.afterInitLogin(response)
        }
      })
      // this.is_reward = 0;
      // this.is_url = null;
      // this.reward_status = false;
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 相关业务方法
    onInvite() {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true)
        return false
      }
      this.shareShow = true
    },
    closeShare() {
      this.shareShow = false
    },
    clickEvent() {
      this.onToast('敬请期待')
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1500,
        className: 'toasts',
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config
      }
      Toast(curConfig)
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/sakura/portrait/enter${getTimeStamp()}`,
        title: '来制作专属小樱头像吧~',
        imgUrl:
          'https://download4.qcplay.com/qcgame-admin/yTzSgoBsGBKICdfLlnUcy1pnfgNagaeLl3bcvtgP.png',
        desc: '《魔卡少女樱透明牌篇》正版授权！制作头像领取限时好礼',
      })
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setLogger',
    ]),
    ...mapActions(['onInitDataCallback', 'onCount', 'setShare']),
  },
}
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/sakura/portrait/index/index.vue